import { API_ROUTES } from '@/constants/apiRoutes';
import { client } from '@/services/client/client';
export interface DropdownOption {
  id: string | number;
  value: string;
  label: string;
}
export const getDropdown = async (params: {
  flag: string;
  value1?: string;
  value2?: string;
  additionalValue1?: string;
}): Promise<DropdownOption[]> => {
  const response = await client.get<{ data: DropdownOption[] }>(API_ROUTES.GET_DROPDOWN_LIST, { params });

  return response?.data?.data || [];
};
